import type { MotionNodeAnimationOptions } from 'motion/react';
import { MOTION_DURATION_SECONDS, MOTION_EASING } from '@_/theme/constants.ts';

export const checkboxAnimationOptions: MotionNodeAnimationOptions = {
  initial: { opacity: 0, paddingLeft: 0, paddingRight: 0, x: '-50%' },
  animate: {
    opacity: 1,
    paddingLeft: 'var(--framer-pl)',
    paddingRight: 'var(--framer-pr)',
    x: '0%'
  },
  exit: { opacity: 0, paddingLeft: 0, paddingRight: 0, x: '-50%' },
  transition: { duration: MOTION_DURATION_SECONDS.base, ease: MOTION_EASING.move }
};
